"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugLog = void 0;
/**
 * Use this function for any debug logging that should not be enabled by default.
 * Developers can enable JIT logging on the browser by setting `window.debugFinleyLog = true`.
 */
const debugLog = (...args) => {
    // always log in Node
    // log in browser only if window.debugFinleyLog is set
    const shouldLog = typeof window === 'undefined' || window.debugFinleyLog;
    if (shouldLog) {
        // eslint-disable-next-line no-console
        console.trace(...args);
    }
};
exports.debugLog = debugLog;
//# sourceMappingURL=finleyLog.js.map